import { AfterViewInit, Component, OnInit, QueryList, ViewChild, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { first, skipWhile } from 'rxjs/operators';
import { SupportModalComponent } from '../../shared/modals/support-modal/support-modal.component';
import { UserProfileModalComponent } from '../../shared/modals/user-profile-modal/user-profile-modal.component';
import { DialogService } from '../../shared/services/dialog.service';
import { UserService } from '../../shared/services/user.service';
import { IconLink, User } from '../../shared/shared.interfaces';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SideNavComponent implements OnInit, AfterViewInit {
    @ViewChildren(SideNavComponent) childrenComponent: QueryList<SideNavComponent>;
    @ViewChild('drawer') drawer: MatDrawer;
    collapsed = false;
    user: any = null;
    links: Array<IconLink> = [
        {
            symbol: 'lock',
            routerLink: '/restricted-product',
            label: 'Accounts',
        },
    ];

    isExpanded = true

    constructor(private userService: UserService, private dialogService: DialogService) {}

    async ngAfterViewInit(): Promise<void> {
        await this.drawer.toggle();
    }

    ngOnInit() {
        this.getUser();
    }

    getUser(): void {
        this.userService.user$
            .pipe(
                skipWhile((user) => user === null),
                first()
            )
            .subscribe((user) => {
                this.user = {
                    email: user.email,
                    firstName: user.given_name,
                    lastName: user.family_name,
                    profileImage: user.picture,
                };
            });
    }

    toggleSideNav(): void {
        this.collapsed = !this.collapsed;
    }

    toggleUserProfileModal(): void {
        this.dialogService.open<User, void>(UserProfileModalComponent, this.user).subscribe();
    }

    toggleSupportModal(): void {
        this.dialogService.open<void, void>(SupportModalComponent).subscribe();
    }
}
